import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppInsightsService {
    appInsights: ApplicationInsights;

    constructor() {
        if (environment.appInsights.isEnable) {
            const appInsightsKey = environment.appInsights.instrumentationKey;
            if (!appInsightsKey) {
                // add custom behavior to handle this scenario
                return;
            }

            this.appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: appInsightsKey,
                    enableAutoRouteTracking: true, // optional: auto-log all route changes
                },
            });

            
            this.appInsights.loadAppInsights();
            this.appInsights.addTelemetryInitializer(t => {
                // Update criteria as per your need.
                if (t.baseType == 'PageviewData' && t.baseData.properties.SubmissionId == undefined) {
                   
                    return false; 
                }

                return true; // enable everything else
              });
        }
    }

    appInsightsObj() {
        return this.appInsights;
    }
}